import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-activitys-popup',
  templateUrl: './activitys-popup.component.html',
  styleUrls: ['./activitys-popup.component.scss']
})
export class ActivitysPopupComponent implements OnInit {

  title = '';
  constructor(
    private dialogRef: MatDialogRef<ActivitysPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  onClose() {
    this.dialogRef.close();
  }

  ngOnInit() {
    if (this.dialogData.args?.title) {
      this.title = this.dialogData.args.title;
    }
  }

}

